{"name":"CATS","fullName":"Chat Auto Translator System","repository":"https://github.com/ProtoKink/CATS"}